import { RecordStore } from '@deqo/foundation';
import { ReplayController } from './ReplayController';

export class ReplayPlayback extends RecordStore({ playing: false }) {

    private timeout = null as any;

    constructor(private replay: ReplayController) {
        super();
        this.burden(() => this.stop());
    }

    public play() {
        this.tick(true);
    }

    public stop() {
        clearTimeout(this.timeout);
        this.updateState({ playing: false });
    }

    private tick = (resetIfRequired: boolean) => {
        const pos = this.replay.getPosition();
        const len = this.replay.getLength();
        if (pos >= len) {
            if (resetIfRequired) {
                this.updateState({ playing: true });
                if (!this.replay.destroyed()) {
                    this.replay.setPosition(0);
                }
                this.timeout = setTimeout(this.tick, 200);
            }
            else {
                this.updateState({ playing: false });
            }
        }
        else {
            this.updateState({ playing: true });
            this.replay.setPosition(pos + 1);
            this.timeout = setTimeout(this.tick, 100);
        }
    };
}
